import React from 'react';
import { XCircle, Users, Lock, Video, Image as ImageIcon } from 'lucide-react';

export const GuestAccessModal = ({ guest, subevents, mediaFiles, onClose, onToggleInvite, onToggleMedia, OnSave }) => {
  if (!guest) return null;

  const privateMedia = (mediaFiles || []).filter(
    (m) => !(m.media_type === "user_public" || m.is_public)
  );

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50 p-4">
      <div className="bg-white w-full max-w-xl rounded-[50px] shadow-2xl p-10 relative">
        <button onClick={onClose} className="absolute top-8 right-8 text-gray-200 hover:text-gray-900"><XCircle size={32}/></button>
        
        <div className="mb-8">
          <span className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-[10px] font-black uppercase">Personalized Access</span>
          <h3 className="text-3xl font-black text-gray-900 mt-2">Personalize {guest.guest.guest_name}</h3>
          <p className="mt-2 text-sm font-semibold text-gray-400">
            Leave unchanged if this guest should receive the standard invite.
          </p>
        </div>

        <div className="space-y-8 max-h-[500px] overflow-y-auto pr-2">
          {/* Subevent Section */}
          <div>
            <h4 className="text-[11px] font-black uppercase text-gray-400 mb-4 flex items-center gap-2"><Users size={14}/> Event Access</h4>
            <div className="grid gap-2">
              {subevents.length === 0 && (
                <p className="rounded-3xl bg-gray-50 p-5 text-sm font-semibold text-gray-400">
                  No separate ceremonies or chapters were found for this event.
                </p>
              )}
              {subevents.map(sub => {
                const accessIds = sub.access_ids || [sub.id];
                const isSelected = accessIds.every((subeventId) =>
                  guest.subevent_links?.some((link) => String(link.subevent_id) === String(subeventId))
                );

                return (
                <label key={sub.id} className="flex items-center justify-between p-5 bg-gray-50 rounded-3xl cursor-pointer hover:border-pink-200 border-2 border-transparent">
                  <span className="font-bold text-gray-700">
                    {sub.title}
                    {sub.linked_page_count > 0 ? (
                      <span className="mt-1 block text-[10px] font-black uppercase tracking-widest text-gray-400">
                        Includes {sub.linked_page_count} linked page{sub.linked_page_count === 1 ? "" : "s"}
                      </span>
                    ) : null}
                  </span>
                  <input 
                    type="checkbox" 
                    checked={isSelected} 
                    onChange={() => onToggleInvite(accessIds, !isSelected)} 
                    className="w-6 h-6 accent-[#ff0099]" 
                  />
                </label>
                );
              })}
            </div>
          </div>

          {/* Media Section */}
          <div>
            <h4 className="text-[11px] font-black uppercase text-gray-400 mb-4 flex items-center gap-2"><Lock size={14}/> Private Chapters</h4>
            <div className="grid gap-2">
              {privateMedia.length === 0 && (
                <p className="rounded-3xl bg-gray-50 p-5 text-sm font-semibold text-gray-400">
                  No private media has been uploaded yet.
                </p>
              )}
              {privateMedia.map((m) => (
                <label key={m.id} className="flex items-center justify-between p-5 bg-gray-50 rounded-3xl cursor-pointer hover:border-purple-200 border-2 border-transparent">
                  <div className="flex items-center gap-3">
                    <span className="text-purple-500">{m.file_type?.includes('video') ? <Video size={18}/> : <ImageIcon size={18}/>}</span>
                    <span className="font-bold text-gray-700">{m.name}</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={guest.media_permissions?.some(p => p.media?.id === m.id)} 
                    onChange={() => onToggleMedia(m.id)} 
                    className="w-6 h-6 accent-purple-600" 
                  />
                </label>
              ))}
            </div>
          </div>
        </div>
        <button onClick={OnSave} className="w-full mt-10 py-5 bg-gray-900 text-white rounded-[30px] font-black text-xl">Done Fine-Tuning</button>
      </div>
    </div>
  );
};
